import { create } from 'zustand';
import type { AdminDashboard, ActiveUser, QueryEvent, ErrorEvent, PerformanceMetrics, SystemHealth, LearningDashboard, LearningUserData } from '@/types/admin';

export type AdminTab = 'users' | 'queries' | 'health' | 'errors' | 'performance' | 'learning';

interface AdminState {
  isOpen: boolean;
  activeTab: AdminTab;
  activeUsers: ActiveUser[];
  queryFeed: QueryEvent[];
  errorLog: ErrorEvent[];
  performance: PerformanceMetrics | null;
  systemHealth: SystemHealth | null;
  lastUpdated: string | null;
  
  // Learning System data
  learningData: LearningDashboard | null;
  selectedUserId: string | null;
  
  setOpen: (open: boolean) => void;
  setActiveTab: (tab: AdminTab) => void;
  updateDashboard: (data: AdminDashboard) => void;
  setLearningData: (data: LearningDashboard) => void;
  setSelectedUserId: (userId: string | null) => void;
}

export const useAdminStore = create<AdminState>((set) => ({
  isOpen: false,
  activeTab: 'users',
  activeUsers: [],
  queryFeed: [],
  errorLog: [],
  performance: null,
  systemHealth: null,
  lastUpdated: null,
  
  // Learning System
  learningData: null,
  selectedUserId: null,

  setOpen: (open) => set({ isOpen: open }),
  setActiveTab: (tab) => set({ activeTab: tab }),
  updateDashboard: (data) =>
    set({
      activeUsers: data.active_users ?? [],
      queryFeed: data.query_feed ?? [],
      errorLog: data.error_log ?? [],
      performance: data.performance ?? null,
      systemHealth: data.system_health ?? null,
      lastUpdated: data.timestamp,
    }),
  setLearningData: (data) => set({ learningData: data }),
  setSelectedUserId: (userId) => set({ selectedUserId: userId }),
}));
